<div class="app_lastUpdate__container">
  <div *ngIf="lastUpdateDate">
    <strong>Última actualización </strong>
    {{ lastUpdateDate }}
  </div>


  <div  class="app_lastUpdate__container__tooltip" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
    <ng-container *ngIf="!isAgenda">
      <app-icon-button class="__icon-button"
        [isConnected]="isConnected"
        (click)="updateExams()"
        messageText="Actualizar"
        icon="../../../../assets/icons/refresh_24px.svg"
      ></app-icon-button>
    </ng-container>

    <ng-container *ngIf="isAgenda">
      <app-icon-button class="__icon-button"
        [isConnected]="isConnected"
        (click)="updateAgendas()"
        messageText="Actualizar"
        icon="../../../../assets/icons/refresh_24px.svg"
      ></app-icon-button>
    </ng-container>

    <span *ngIf="!isConnected">
      <button  class="app_lastUpdate__container__button">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <defs>
          <style>.bad6affb-2ec5-4f6a-988a-adc5cf9ded47{fill:#2c4352;}.e1d73c7f-8e67-447e-9ab4-94cf8cb3a0f5{fill:none;}</style>
          </defs>
          <g id="bb233d3e-f114-4862-8701-c3e21bb785be" data-name="Kit_1_rounded_proportion">
          <g id="a4c4dc85-4218-4a15-b601-cb265ac96e67" data-name="Grid_warning_error">
          <rect class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47" x="10.99" y="9" width="2" height="6" rx="1"/>
          <circle id="bea05e1f-6a62-47a1-b3b7-240c09ff4c44" data-name="Elipse 3" class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47" cx="11.99" cy="17.06" r="1.1"/>
          <path class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47" d="M21.33,19,13.91,3.22a2.12,2.12,0,0,0-3.84,0L2.65,19a2.12,2.12,0,0,0,1.92,3H19.41A2.12,2.12,0,0,0,21.33,19ZM4.38,20,12,3.84,19.6,20Z"/>
          <path class="e1d73c7f-8e67-447e-9ab4-94cf8cb3a0f5" d="M0,0H24V24H0Z"/>
          </g>
          </g>
          </svg>
      </button>
    </span>
    <span *ngIf="tooltipIsVisible" class="app_lastUpdate__container__tooltip__tooltiptext"><a>Opción <strong>Actualizar</strong> solo disponible con conexión.</a></span>
  </div>
  <label *ngIf="mostrarMensajeDeFiltrosActivos" style="margin: auto 0;" class="label">
    Búsqueda realizada sobre el resultado (Por defecto y/o Personalizado).
  </label>

  <div>
    <ng-container *ngIf="!isAgenda">
    <div class="tooltip">
      <app-icon-button class="__icon-button"
        [isConnected]="isConnected"
        (click)="openModalResumen()"
        messageText="Ver Resumen"
        icon="../../../../assets/icons/alerta.svg"
        [disabled]="habilitarResumen"
      ></app-icon-button>
      <div *ngIf="!isConnected">
        <button class="app_lastUpdate__container__button">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <defs>
            <style>.bad6affb-2ec5-4f6a-988a-adc5cf9ded47{fill:#2c4352;}.e1d73c7f-8e67-447e-9ab4-94cf8cb3a0f5{fill:none;}</style>
            </defs>
            <g id="bb233d3e-f114-4862-8701-c3e21bb785be" data-name="Kit_1_rounded_proportion">
            <g id="a4c4dc85-4218-4a15-b601-cb265ac96e67" data-name="Grid_warning_error">
            <rect class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47" x="10.99" y="9" width="2" height="6" rx="1"/>
            <circle id="bea05e1f-6a62-47a1-b3b7-240c09ff4c44" data-name="Elipse 3" class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47" cx="11.99" cy="17.06" r="1.1"/>
            <path class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47" d="M21.33,19,13.91,3.22a2.12,2.12,0,0,0-3.84,0L2.65,19a2.12,2.12,0,0,0,1.92,3H19.41A2.12,2.12,0,0,0,21.33,19ZM4.38,20,12,3.84,19.6,20Z"/>
            <path class="e1d73c7f-8e67-447e-9ab4-94cf8cb3a0f5" d="M0,0H24V24H0Z"/>
            </g>
            </g>
            </svg>
        </button>
        <span class="tooltip-text" *ngIf="!isConnected">
          Opción <strong>Ver Resumen</strong> solo disponible con conexión.
        </span>
      </div>
    </div>
    <app-modal-resumen [isOpen]="isModalResumenOpen" (close)="closeModalResumen()"></app-modal-resumen>
    </ng-container>
  </div>
</div>
